<template>
  <div>
    <color-picker
      theme="light"
      :color="color"
      :colors-default="palette"
      :sucker-hide="false"
      :sucker-canvas="suckerCanvas"
      :sucker-area="suckerArea"
      @changeColor="changeColor"
      @openSucker="openSucker"
    />
  </div>
</template>

<script>
import colorPicker from '@caohenghu/vue-colorpicker';

export default {
  components: {
    colorPicker,
  },
  props: {
    colorScrap: {
      type: String,
      default: null,
    },
    palette: {
      type: Array,
      default: () => [
        '#000000',
        '#FFFFFF',
        '#FF1900',
        '#F47365',
        '#FFB243',
        '#FFE623',
        '#6EFF2A',
        '#1BC7B1',
        '#00BEFF',
        '#2E81FF',
        '#5D61FF',
        '#FF89CF',
        '#FC3CAD',
        '#BF3DCE',
        '#8E00A7',
        'rgba(0,0,0,0)',
      ],
    },
  },
  data() {
    return {
      color: '#59c7f9',
      defaultPalette: [
        '#000000',
        '#FFFFFF',
        '#FF1900',
        '#F47365',
        '#FFB243',
        '#FFE623',
        '#6EFF2A',
        '#1BC7B1',
        '#00BEFF',
        '#2E81FF',
        '#5D61FF',
        '#FF89CF',
        '#FC3CAD',
        '#BF3DCE',
        '#8E00A7',
        'rgba(0,0,0,0)',
      ],
      suckerCanvas: null,
      suckerArea: [],
      isSucking: false,
    };
  },
  created() {
    if (this.colorScrap) {
      this.color = this.colorScrap;
    }
  },
  methods: {
    changeColor(color) {
      // color contains .hex, .rgba & .hsv
      // const { r, g, b, a } = color.rgba
      // this.color = `rgba(${r}, ${g}, ${b}, ${a})`
      this.$emit('changeColor', color.hex);
    },
    openSucker(isOpen) {
      if (isOpen) {
        // ... canvas be created
        // this.suckerCanvas = canvas
        // this.suckerArea = [x1, y1, x2, y2]
      } else {
        // this.suckerCanvas && this.suckerCanvas.remove
      }
    },
  },
};
</script>

<style>
.hu-color-picker {
  width: 220px !important;
}

.color-type {
  display: none !important;
}

.color-show {
  display: none !important;
}

.color-alpha {
  display: none !important;
}
</style>
